import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/idnp-automations/playbooks/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.featureFlags[FeatureFlags.GartnerDemo];
    context.validatePermissions({ isAllowed, preload });
  },
});
